import intlTelInput from 'intl-tel-input'
import IMask from 'imask'
import 'intl-tel-input/build/css/intlTelInput.css'
import Collection from './generic/collection'

const instance = '[data-js-phone-picker]'

class PhonePicker {
  constructor (instance) {
    this.instance = instance
    this.intTelInput = null
    this.mask = null
    this.init()
  }

  init () {
    this.createPhonePicker(this.instance)
  }

  normalZero (targetStr) {
    if (targetStr) {
      return targetStr.replace('0', '\\0')
    } else {
      return ''
    }
  }

  createPhonePicker (input) {
    if (input.value) {
      input.value = `+${input.value}`
    }
    this.intTelInput = intlTelInput(input, {
      nationalMode: true,
      initialCountry: 'auto',
      autoPlaceholder: 'aggressive',
      formatOnDisplay: false,
      utilsScript: window.SITE_TEMPLATE_PATH ? window.SITE_TEMPLATE_PATH + '/frontend/assets/phoneUtils/index.js' : (window.App.debug) ? './phoneUtils/index.js' : '/frontend/assets/phoneUtils/index.js',
      geoIpLookup: function (callback) {
        $.ajax({
          type: 'GET',
          url: 'https://ipinfo.io?token=fbcb203a068b6c',
          processData: false,
          contentType: false,
          success: function (resp) {
            var countryCode = (resp && resp.country) ? resp.country : 'ru'
            callback(countryCode)
          },
          error: function () {
            var countryCode = 'ru'
            callback(countryCode)
          }
        })
      },
      customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
        const flag = Object.keys(selectedCountryData)
        return `${flag.length === 0 ? '' : ''} ${selectedCountryPlaceholder}`
      }
    })

    this.intTelInput.promise.then(() => {
      const maskOptions = this.getMaskOptions()
      this.createImask(maskOptions)
      input.addEventListener('countrychange', (e) => {
        this.changeMask(e)
      })
    })
  }

  createImask (maskOptions) {
    const countryData = this.intTelInput.getSelectedCountryData()
    if (!countryData.name.search('Russia') >= 0) {
      if (this.instance.value) {
        this.instance.value = this.instance.value.slice(this.intTelInput.getSelectedCountryData().dialCode.length)
      }
    }

    if (!this.instance.iMask) {
      this.instance.iMask = new IMask(this.instance, maskOptions)
    } else {
      this.instance.iMask.updateOptions(maskOptions)
    }
  }

  getMaskOptions () {
    const countryData = this.intTelInput.getSelectedCountryData()
    let newMask = ''
    if ((countryData.name.search('Russia') >= 0) || (countryData.name.search('Kazakhstan') >= 0)) {
      /* newMask = `${dialCode} ${input.placeholder.replace(8, '').replace(/\d/g, 0).trim()}` */
      newMask = {
        mask: [
          {
            mask: '+7 (000) 000 00 00',
            startsWith: '+'
          },
          {
            mask: '+7 (000) 000 00 00',
            startsWith: '7',
            lazy: true
          },
          {
            mask: '+7 (000) 000 00 00',
            startsWith: '',
            lazy: true
          },
        ],
        prepare: function (appended, masked) {
          if (appended === '8' && masked.value === '') {
            return '+7'
          /* } /*else if (appended.startsWith('8')) {
            return appended.slice(1, appended.length) */
          }
          return appended
        }
      }
    } else {
      newMask = { mask: `${this.normalZero(countryData.dialCode)} ${this.instance.placeholder.replace(/\d/g, 0).trim()}` }
    }
    return newMask
  }

  changeMask () {
    const maskOptions = this.getMaskOptions()
    this.createImask(maskOptions)
    this.instance.iMask.updateValue()
  }
}

export class PhonePickerCollection extends Collection {
  constructor () {
    super(instance, PhonePicker)
    this.init()
  }

  init () {
    $(instance).each((index, el) => {
      this.collection = new PhonePicker(el)
    })
  }
}
